// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSnackbarComponent } from './components/custom-snackbar/custom-snackbar.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    CustomSnackbarComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MatIconModule,
  ],
})
export class CustomSnackbarModule {
}
